<template lang="pug">
  include ./../../mixins
  div
    validation-observer(
      tag="form"
      ref="observer"
      v-slot="props"
      @submit.prevent="validateBeforeSubmit"
    )
 
      +b.g-row--space_lg
        +b.g-cell.g-cols--12.--6-md
          validation-provider.position_relative(
            tag="div"
            v-slot="{errors}"
            rules="alpha_spaces"
            name="name"
          )
            
            +b.form--input.margin_bottom_lg.INPUT(
              placeholder="First Name"
              type='text'
              name='name'
              required
              v-model="formdata.name"

            )
            +b.error-text--contact.SPAN {{ errors[0] }}
          validation-provider.position_relative(
            tag="div"
            v-slot="{errors}"
            rules="alpha_spaces"
            name="lastname"
          )
            +b.form--input.margin_bottom_lg.INPUT(
              placeholder="Last Name"
              type='text'
              required
              name='lastname'
              v-model="formdata.lastname"
            )
            +b.error-text--contact.SPAN {{ errors[0] }}

          validation-provider.position_relative(
            tag="div"
            v-slot="{errors}"
            rules="email"
            name="email"
          )
            +b.form--input.margin_bottom_lg.INPUT(
              placeholder="Email Address"
              type='text'
              required
              name='email'
              v-model="formdata.email"
            )
            +b.error-text--contact.SPAN {{ errors[0] }}

        +b.g-cell.g-cols--12.--6-md
          validation-provider.position_relative(
            tag="span"
            v-slot="{errors}"
            rules="alpha_spaces"
            name="message"
          )
            +b.form--textarea.margin_bottom_lg.TEXTAREA(
              placeholder="Describe your project in a few sentences"
              type='text'
              name='message'
              required
              v-model="formdata.message"
            )
            +b.error-text--textarea.SPAN {{ errors[0] }}
      
      +b.g-row--space_lg
        +b.g-cell.g-cols--12.--6-md
          +b.g-row--align_center.position_relative
            +b.g-cell.g-cols--auto
              +b.text_right.color_darkgray.fs_2sm.P {{firstNumber}} + {{secondNumber}} = 
            +b.g-cell.g-cols--narrow
              validation-provider.position_relative(
                tag="span"
                v-slot="{errors}"
                :rules="{ required: { allowFalse: false } }"
                name="formCaptcha"
              )
                +b.form--captcha.INPUT(
                  type='text'
                  v-model='formCaptcha'
                  @input='checkValue'
                  name='formCaptcha'
                )
                +b.error-text--captcha.SPAN {{ errors[0] }}
                +b.error-text--captcha.SPAN(v-if='errorText.length !== 0') {{ errorText }}
        +b.g-cell.g-cols--12.--6-md.margin_top_sm-till-md
          +b.button--color_green.--width_full.padding_full_md.text_uppercase.font-weight_bold.display--block.cursor-pointer.BUTTON(
            @click.prevent="validateBeforeSubmit"
            :disabled='clicked'
            type='submit'
          ) {{buttonName}}
</template>
<script>
  import axios from 'axios'
  import Success from './../Modal/SuccessModal.vue'
  export default {
    props: {
      buttonName: {
        type: String
      },
      url: {
        type: String
      }
    },
    data() {
      return {
        errorText: '',
        firstNumber: 0,
        clicked: false,
        secondNumber: 0,
        formCaptcha: '',
        formdata: {
          name: '',
          lastname: '',
          email: '',
          message: '',
        }
      }
    },

    mounted() {
      this.generateSumNumber()
      // console.log(this.firstNumber, this.secondNumber)
    },

    methods: {
      checkValue() {
        let reg = /^\d+$/
        let result = this.formCaptcha.match(reg)
        if (this.formCaptcha.length > 0 && result == null ) {
          this.errorText = 'Please, input a valid value'
        } else {
          this.errorText = ''
        }
        // console.log(result)
      },

      getRandom(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min
      },

      generateSumNumber() {
        this.firstNumber = this.getRandom(1,10)
        this.secondNumber = this.getRandom(2, 7)
      },

      checkCaptcha() {
        let sum = this.firstNumber + this.secondNumber
        // console.log(sum)
        // console.log(this.formCaptcha)
        if (this.formCaptcha == sum) {
          this.formSubmit()
        }
      },

      formSubmit() {
        this.clicked = true
        axios.post(this.url, {
          data: this.formdata
        })
          .then((res) => {
            this.$refs.observer.reset()
            // console.log(res)
            Object.keys(this.formdata).forEach(key => {
              this.formdata[key] = ''
            })
            this.firstNumber = ''
            this.secondNumber = ''
            this.formCaptcha = ''
            this.generateSumNumber()
            console.log(res)
            this.showModal(res.data.title, res.data.message)
            this.clicked = false
          })
      },
      async validateBeforeSubmit() {
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          let sum = this.firstNumber + this.secondNumber
          // console.log(sum)
          // console.log(this.formCaptcha)
          if (this.formCaptcha == sum) {
            this.formSubmit()
          } else if (this.formCaptcha !== sum) {
            this.errorText = 'Enter the correct number'

          }
          // this.formSubmit()
        } else {
          return
        }
      },
      showModal(title, text) {
        console.log(title, text)
        this.$modal.show(Success, {
          title: title,
          text: text

        }, {
          classes: "modal modal--container",
          name: "success"
        })
      },

    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/UiForm/UiForm.vue